import React, { ReactNode } from 'react';

// Material-ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Styles
import '../Filters.scss';

interface Props {
    label: string;
    children: ReactNode;
    icon?: ReactNode;
    className?: string;
}

const Inputs: React.FC<Props> = ({
    label,
    children,
    icon,
    className = ''
}) => (
    <Grid
        className={className}
        container
        wrap="nowrap"
    >
        <Typography
            className="ui-Filters-label"
            variant="input-head"
            color="primary-dark"
        >
            {`${label}:`}
        </Typography>
        <Grid
            className="ui-Filters-input-container"
            item
            container
        >
            {children}
        </Grid>
        { icon && (
            <Grid
                item
            >
                {icon}
            </Grid>
        )}
    </Grid>
);

export default Inputs;
